export default __webpack_public_path__ + "static/media/DNo.35-5.251eba96.jpg";